import type { TowerKind } from './towers'

export interface TowerAbilityDefinition {
  readonly towerKind: TowerKind
  readonly name: string
  readonly codename: string
  readonly description: string
  readonly cooldownMs: number
}

export const TOWER_ABILITIES: Record<TowerKind, TowerAbilityDefinition> = {
  SOL: { towerKind: 'SOL', name: 'MEMPOOL PURGE', codename: 'CHAIN BURST', description: 'Discharges into multiple hostiles inside the tower network.', cooldownMs: 22_000 },
  ETH: { towerKind: 'ETH', name: 'CONSENSUS LOCK', codename: 'STASIS FIELD', description: 'Slows every hostile inside the validator field for five seconds.', cooldownMs: 26_000 },
  BTC: { towerKind: 'BTC', name: 'FINALITY SHOT', codename: 'TRUE DAMAGE', description: 'Fires a massive armor-ignoring round at the strongest target.', cooldownMs: 30_000 },
}
